/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 22/11/2022
 */

import { useContext } from 'react';
import {
    IWorkplanVersionContext,
    WorkplanVersionContext,
} from '@/components/contexts/VersionContext/WorkplanVersionProvider';

function useWorkplanVersion(): IWorkplanVersionContext {
    return useContext(WorkplanVersionContext);
}

export default useWorkplanVersion;
